import { render } from "./AddUserToProduct.vue?vue&type=template&id=e8b14b86"
import script from "./AddUserToProduct.vue?vue&type=script&lang=js"
export * from "./AddUserToProduct.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/historedez-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__